import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { forkJoin } from 'rxjs';
import { EventEmitter } from "events";
import { DialogData } from "src/app/entities/dialogData";
import { Forecast } from "src/app/entities/forecast";
import { CategoryService } from "src/app/services/category.service";
import { ForecastService } from "src/app/services/forecast.service";
import { SharedService } from "src/app/services/sharedService";
import { MultiselectAutocompleteComponent } from "../../multiselect-autocomplete/multiselect-autocomplete.component";
import { DialogCommunicator } from "../dialog-communicator";
import { PaymentReportService } from "src/app/services/paymentReport.service";
import { AvisService } from "src/app/services/avis.service";

@Component({
  selector: "rdf-forecast-dialog",
  templateUrl: "./forecast-dialog.component.html",
  styleUrls: ["./forecast-dialog.component.css"],
})
export class ForecastDialogComponent
  extends DialogCommunicator
  implements OnInit {
  text: string;
  emitter: EventEmitter;
  forecast: any;
  selectedRevenue = [];
  previousYearForecast: number = null;
  previousYearPaymentsTotal: number = null;
  activeRecursionsTotal: number = null;
  previousInfoLoading = false; 
  @ViewChild("revenueCodeSelect", { static: false })
  revenueCodeSelect: MultiselectAutocompleteComponent;
  FEE_TYPES = [ 'AMOUNT', 'PERCENTAGE']
  filterData = {
    revenueCode: null,
  };
  performance = false;
  month;
  constructor(
    public dialogRef: MatDialogRef<ForecastDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public sharedService: SharedService,
    private categoryService: CategoryService,
    private confirmationDialog: MatDialog,
    private forecastService: ForecastService,
    private paymentReportService: PaymentReportService,
    private avisService: AvisService
  ) {
    super(dialogRef, sharedService);
    this.setConfirmationDialog(this.confirmationDialog);
  }

  ngOnInit() {
    this.performance = this.data['performance']
    this.month = this.data['month']
    this.categoryService.getList("revenue-code").subscribe((result) => {
      if (result) {
        let forecastFilter = { "municipality": [this.data['municipalityId']], "year": this.data['year'] }
        let existingRevenueCodes = []
        this.forecast = new Forecast();

        delete this.data['performance']
        delete this.data['month']
        for (let key in this.data) {
          if (key === 'forecast') {
            for (let fr in this.data['forecast']) {
              if (fr === "id") this.forecast["id"] = this.data['forecast'][fr];
              else
                this.forecast[fr] = this.data['forecast'][fr];
            }
          }
          else this.forecast[key] = this.data[key];
        }
       
        this.forecastService.getList('forecast/dialoglist', '?filter.object=' + encodeURIComponent(JSON.stringify(forecastFilter))).subscribe(forecasts => {
          if (forecasts && forecasts.records) {
            existingRevenueCodes = forecasts.records.map(fr => fr.revenueCode);
            this.forecast["revenueCode"] && (existingRevenueCodes = existingRevenueCodes.filter(elem => elem !== this.forecast['revenueCode']))
          }
          this.filterData["revenueCode"] = result.map((fld) => ({
            name: fld.name,
            id: fld.id,
            code: fld.code,
            altName: fld.name
          })).filter(obj => !existingRevenueCodes.includes(obj.code));
          if (this.forecast["revenueCode"])
            this.selectedRevenue =
              [
                this.filterData["revenueCode"].find(
                  (elem) => elem.code === this.forecast["revenueCode"]
                ),
              ] || [];
              const revCode = this.selectedRevenue[0];
              if (revCode) {
                this.loadPreviousYearData(revCode.code);
              }
          this.forecast["class"] = "FORECAST";
          this.forecast["amountEdit"] = this.isAmountEditOnly();
          this.setEntity(this.forecast);
        })
      }
    });
  }

  isAmountEditOnly() {
    return this.data['forecastState'] && this.data['forecastState'].state === 'REOPENED_AMOUNT_EDIT';
  }
  selectChange = (event: any) => {
    let revCode = event.data[0];
    this.forecast["revenueCodeId"] = (revCode && revCode.id) || null;
    this.forecast["revenueCode"] = (revCode && revCode.code) || null;
    this.forecast["revenueCodeName"] = (revCode && revCode.name) || null;
    if (revCode && this.data['municipalityId'] && this.data['year']) {
      this.loadPreviousYearData(revCode.code);
    } else {
      this.previousYearForecast = null;
      this.previousYearPaymentsTotal = null;
      this.activeRecursionsTotal = null;
    }
  };

  private loadPreviousYearData(revenueCode: string) {
    const municipalityId = this.data['municipalityId'];
    const currentYear = this.data['year'];
    const prevYear = (parseInt(currentYear, 10) - 1).toString();

    this.previousYearForecast = null;
    this.previousYearPaymentsTotal = null;
    this.activeRecursionsTotal = null;
    this.previousInfoLoading = true;

    forkJoin({
      forecast: this.forecastService.getPreviousYearForecast(
        municipalityId,
        prevYear,
        revenueCode
      ),
      payments: this.paymentReportService.getPreviousYearPaymentsTotal(
        municipalityId,
        currentYear,
        revenueCode
      ),
      active: this.avisService.getActiveAvisTotal(
        municipalityId,
        currentYear,
        revenueCode
      )
    }).subscribe({
      next: (res: any) => {
        this.previousYearForecast =
          res.forecast && res.forecast.forecast != null
            ? res.forecast.forecast
            : null;

        this.previousYearPaymentsTotal =
          res.payments && res.payments.total != null
            ? res.payments.total
            : null;

        this.activeRecursionsTotal =
          res.active && res.active.total != null
            ? res.active.total
            : null;
      },
      error: (err) => {
        console.error('Error loading previous data block', err);
        this.previousYearForecast = null;
        this.previousYearPaymentsTotal = null;
        this.activeRecursionsTotal = null;
        this.previousInfoLoading = false;
      },
      complete: () => {
        this.previousInfoLoading = false;
      }
    });
  }

  addFee(name, description, type,amount){
    this.forecast.fees.push({name:name.value, description:description.value, type:type.value, amount:amount.value})
    name.value = null 
    type.value = null 
    amount.value = null 
  }
  removeFee(index){
    this.forecast.fees.splice(index, 1)
  }
}
